<template>
  <div class="logincomponent">
    <div class="logincontainer d-flex d-flex justify-content-around flex-wrap">
        <div class="loginhero d-flex flex-column align-self-center">
           <h3>{{$lang('hero')}}</h3> 
           <p>{{$lang('heroDesc')}}</p>
        </div>
        <div class="loginform d-flex shadow">
            <form autocomplete="off" class="w-100" @submit.prevent="DoSubmit()">
              <h3 class="mb-4">Login</h3>       
              <div class="form-group mb-4">
                <input v-model="userName" type="text" name="user_name" class="form-control" :placeholder="$lang('username')" required="required">
              </div>
              <div class="form-group mb-4">
                <input v-model="userPass" type="password" autocomplete="off" name="user_pass" class="form-control" :placeholder="$lang('pass')" required="required">
              </div>
              <div>
                <b-alert v-if="loginError" show variant="danger">{{loginError}}</b-alert>
              </div>
              <button type = "submit" class="btn btn-primary btn-block">
                <b-spinner v-if="wait" small></b-spinner>
                <span>{{$lang('dologin')}}</span> 
              </button>
              <div>
                <!-- <b-form-checkbox v-model="remember" name ="remember_me"> {{$lang('remember')}}</b-form-checkbox> -->
              </div>        
            </form>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import md4 from './md4.js'
export default {
    methods:{
       DoSubmit() {
        this.wait = 1;
        var lData = {
           userName: this.userName,
           userHash: md4.hex_md4(this.userPass),
           remember: this.remember,
        }
        this.loginError = null;
        axios.post('/api/login', lData)
        .then(resp => {
          this.wait = null;
          this.$store.dispatch('updateUserInfo')
        })
        .catch(err => {
          this.wait = null;
          this.loginError = err.message;
          if (err.response.data.message)
             this.loginError = err.response.data.message;
          else if (err.response.data)
             this.loginError = err.response.data;
        })
       }
    },
    data() {
      return {
        userName: null,
        userPass: null,
        remember: false,
        loginError: null, 
        wait: null,
      }
    },
    locales: {
      en: {
        hero: "Login to get access to services.",
        heroDesc: "Please use you default username and password to login",
        username: "Username",
        pass: "Password",
        remember: "Remember me",
        dologin: "Log in",
      },
      de: {
        hero: "Melden Sie sich an, um Zugriff auf Dienste zu erhalten.",
        heroDesc: "Bitte verwenden Sie Ihren Standard-Benutzernamen und Ihr Passwort, um sich anzumelden",
        username: "Benutzername",
        pass: "Passwort",
        remember: "Erinnere mich",
        dologin: "Anmelden",
      },
      ru: {
        hero: "Вход для работы с сервисами.",
        heroDesc: "Используйте свое имя пользователя и пароль для входа",
        username: "Имя пользователя",
        pass: "Пароль",
        remember: "Запомнить меня",
        dologin: "Войти",
      },
      pl: {
        hero: "Zaloguj się, aby pracować z usługami.",
        heroDesc: "Aby się zalogować, użyj swojej nazwy użytkownika i hasła",
        username: "Nazwa użytkownika",
        pass: "Hasło",
        remember: "Zapamiętaj mnie",
        dologin: "Zaloguj sie",
      },
  }
}
</script>

<style scoped>

.loginform {
  min-height: 290px;
  width: 350px;
  padding: 24px;
  background: #546FF9;
  background: -webkit-linear-gradient(top left, rgb(69, 90, 197), #31287D);
  background: -moz-linear-gradient(top left, rgb(69, 90, 197), #31287D);
  background: linear-gradient(to bottom right, rgb(69, 90, 197), #31287D);
  margin: 1rem 0 2rem 0;  
  color: #eee;
}

.loginhero {
    min-height: 100px;
    max-width: 420px;
    color: #555;
}

</style>



// WEBPACK FOOTER //
// src/Login.vue